import { generatePath } from 'react-router-dom'

import { licenseSlice } from '@/store/licenseSlice'
import { useAppSelector } from './store'

export const useAppPath = (path: string) => {
  const license = useAppSelector(licenseSlice.selectors.licenseCode)
  return generatePath(path, { license })
}
